import AllContactInfo from './AllContactInfo';

export default AllContactInfo;
